import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import closeAddDriver from "../../../../../../../assets/images/addDriver/closeAddDiver.svg";
import addDrivingLicense from "../../../../../../../assets/images/addDriver/addDrivingLicense.svg";
import "./AddDriverModal.scss";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import Icon from "app/views/commonComponents/Icon/Icon";
import arrowRightInput from "../../../../../../../assets/images/addDriver/arrowRightInput.svg";
import arrowLeftImage from "../../../../../../../assets/images/addDriver/arrowLeftImage.svg";
import AddDriverLicense from "../AddDriverLicense/AddDriverLicense";
import AddDriverInput from "../AddDriverInput/AddDriverInput";
import Loader from "react-js-loader";
const AddDriverModal = ({ onClose, sendDriverAdded }) => {
  const [showInputSection, setShowInputSection] = useState(false);
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [isDriverAdded, setIsDriverAdded] = useState(false);
  console.log("front1", frontImage);
  console.log("front2", backImage);
  const handleFrontImageSelect = (image) => {
    setFrontImage(image);
  };

  const handleBackImageSelect = (image) => {
    setBackImage(image);
  };
  const handleShowInputSection = () => {
    setShowInputSection(!showInputSection);
  };
  const handleDriverAdded = (value) => {
    console.log("isDriverAdded3", value);
    setIsDriverAdded(value);
    sendDriverAdded(value);
  };
  return (
    <Card
      // className={
      //   showInputSection ? "addDriverInputCard" : "addDriverLicenseCard"
      // }
      className={"addDriverInputCard"}
    >
      <CardBody>
        <div className="addDriverContainer">
          <div className="addDriverTitle">
            <div className="addDriverStyle">Add Driver</div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {/* {showInputSection && (
                <Buttons
                  dimensions={"responsive"}
                  size={"regular"}
                  buttonType={"secondary"}
                  //iconPosition={"left"}
                  //image={arrowLeftImage}
                  onClick={handleShowInputSection}
                  color={"#FF4E00"}
                >
                  Upload Driving Licence
                </Buttons>
              )} */}
              <Icon
                size="regular"
                buttonType="secondary"
                image={closeAddDriver}
                onClick={onClose}
              ></Icon>
            </div>
          </div>
          <>
            {/* {showInputSection == false && (
            <>
              <AddDriverLicense
                onFrontImageSelect={handleFrontImageSelect}
                onBackImageSelect={handleBackImageSelect}
              />
              {frontImage == null || backImage == null ? (
                <div className="uploadButtonSection">
                  <Buttons
                    dimensions={"responsive"}
                    size={"regular"}
                    buttonType={"primary"}
                    disabled={
                      frontImage == null || backImage == null ? true : ""
                    }
                  >
                    Upload
                  </Buttons>
                  <Buttons
                    dimensions={"responsive"}
                    size={"regular"}
                    buttonType={"secondary"}
                    iconPosition={"right"}
                    image={arrowRightInput}
                    onClick={handleShowInputSection}
                  >
                    I'd like to input the details manually.
                  </Buttons>
                </div>
              ) : (
                <div className="loadingDetails">
                  <div className="loaderContainer">
                    <Loader
                      type="spinner-circle"
                      bgColor={"#6B6C72"}
                      color={"#6B6C72"}
                      // title={"spinner-circle"}
                      size={50}
                    />
                  </div>
                  <div className="fetchDetails">Fetching Details</div>
                </div>
              )}
            </>
          )} */}
          </>
          {<AddDriverInput onClose={onClose} onDriverAdd={handleDriverAdded} />}
        </div>
      </CardBody>
    </Card>
  );
};

export default AddDriverModal;
